export function isDarkColor(hex: string): boolean {
  const rgb = hexToRgb(hex);

  if (!rgb) return false;

  const luminance = getLuminance(rgb.r, rgb.g, rgb.b);

  return luminance < 0.5;
}

function hexToRgb(hex: string) {
  const cleaned = hex.replace('#', '');

  const fullHex =
    cleaned.length === 3
      ? cleaned
          .split('')
          .map((c) => c + c)
          .join('')
      : cleaned;

  const num = parseInt(fullHex, 16);

  return {
    r: (num >> 16) & 255,
    g: (num >> 8) & 255,
    b: num & 255,
  };
}

function getLuminance(r: number, g: number, b: number) {
  const [rs, gs, bs] = [r, g, b].map((v) => {
    v = v / 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });

  return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
}
